import { render, staticRenderFns } from "./SchoolIndex.vue?vue&type=template&id=c853b47c&scoped=true&"
import script from "./SchoolIndex.vue?vue&type=script&lang=js&"
export * from "./SchoolIndex.vue?vue&type=script&lang=js&"
import style0 from "./SchoolIndex.vue?vue&type=style&index=0&id=c853b47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c853b47c",
  null
  
)

export default component.exports